import { ArrowForwardIosRounded } from '@mui/icons-material';
import { Box, Divider, FormControlLabel, IconButton, Radio } from '@mui/material';
import { ITenantWithRoles } from 'types/queries';
import { IRole } from 'views/backoffice/roles/types';
import { CustomLabel } from '.';
import { RoleSelectorMode } from '../types';

export type ListItemProps = {
    onChange: (tenant: ITenantWithRoles | Pick<IRole, 'name' | 'id'> | null) => void;
    item: ITenantWithRoles | Pick<IRole, 'name' | 'id'>;
    selected: boolean;
    setRoleSelectorMode?: (roleSelectorMode: RoleSelectorMode) => void;
    setSearchText?: (searchText: string) => void;
};

export const ListItem = ({ item, onChange, selected, setRoleSelectorMode, setSearchText }: ListItemProps) => {
    const isTenant = 'tenant' in item;

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
            <FormControlLabel
                sx={{ width: '88%', margin: '0', padding: '0' }}
                value={isTenant ? item.tenant.id.toString() : item.id.toString()}
                control={<Radio />}
                label={
                    <CustomLabel
                        name={isTenant ? item.tenant.name : item.name}
                        description={isTenant ? item.tenant.description : undefined}
                    />
                }
                checked={selected}
                onChange={() => onChange?.(item)}
            />
            {isTenant && item.roles.length > 1 && (
                <>
                    <Divider orientation="vertical" flexItem variant="middle" />
                    <IconButton
                        sx={(theme) => ({ ml: '8px', backgroundColor: theme.palette.primary[300] })}
                        onClick={() => {
                            setRoleSelectorMode?.(RoleSelectorMode.MULTIPLE);
                            onChange?.(item);
                            setSearchText?.('');
                        }}
                    >
                        <ArrowForwardIosRounded sx={{ fontSize: '20px' }} />
                    </IconButton>
                </>
            )}
        </Box>
    );
};
